var localeFromURL = (window.location.href).split('/')[3];
var pageFromURL = (window.location.href).split('/')[4];
var mySonyURL = (window.location.href).split('/')[5];

if(typeof localeFromURL === "undefined" || localeFromURL.length <1) localeFromURL="";
if(typeof pageFromURL === "undefined" || pageFromURL.length <1) pageFromURL="home";
if(typeof mySonyURL === "undefined" || mySonyURL.length <1) mySonyURL="";

var domainHostname = (window.location.href).split('/')[2].substring(0, 5);
var domainEnvSource = domainHostname == "store" ? "www" : domainHostname.substring(0, 3) == "stg" ? "uat-pdp" : "test";

localeFromURL = localeFromURL.toLowerCase();
pageFromURL = pageFromURL.toLowerCase();
mySonyURL = mySonyURL.toLowerCase();

var locale = "";
var counrty = "";
var language = "";
var domain = 'https://' + domainEnvSource + '.sony.com.my';
switch (localeFromURL) {
    case "sg":
        locale = "en_SG";
        country = "SG";
        language = "en";
        domain = 'https://' + domainEnvSource + '.sony.com.sg';
        break;
    case "my":
        locale = "en_MY";
        country = "MY";
        language = "en";
        domain = 'https://' + domainEnvSource + '.sony.com.my';
        break;
    case "en-th":
        locale = "en_TH";
        country = "TH";
        language = "en";
        domain = 'https://' + domainEnvSource + '.sony.co.th';
        break;
    case "vn":
        locale = "vi_VN";
        country = "VN";
        language = "vi";
        domain = 'https://' + domainEnvSource + '.sony.com.vn';
        break;
    case "th":
        locale = "th_TH";
        country = "TH";
        language = "th";
        domain = 'https://' + domainEnvSource + '.sony.co.th';
        break;
    default:
        locale = "vi_VN";
        country = "VN";
        language = "vi";
        domain = 'https://' + domainEnvSource + '.sony.com.vn';
}

var toggleWoff2Font = true;

var fontType = (function () {
    var supportsWoff2 = (function (win) {
        if (!("FontFace" in win)) return false;
        var f = new win.FontFace('t', 'url(data:application/font-woff2;charset=utf-8;base64,) format("woff2")', {});
        f.load().catch(function () { });
        return f.status == 'loading';
    })(this);

    function requiresTTF() {
        return navigator.userAgent.toLowerCase().match(/android|vita|playstation/g) !== null;
    }

    if (supportsWoff2) {
        return ".woff2";
    }
    else if (requiresTTF()) {
        return ".ttf";
    }
    else {
        return ".woff";
    }

})();

function getURLParameterbyName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function loadFont(fontFamily, url) {
    var font = new FontFace(fontFamily, "url('" + url + fontType + "')");
    font.load();
    document.fonts.add(font);
}

var str = ["%3Clink rel='stylesheet' href='https://fonts.sony.net/shf/v31/latinextended/base.css'%3E"];
str.push("%3Clink rel='stylesheet' href='" + 'https://fonts.sony.net/shf/icons/system/v17/Sony-System-Icons.css' + "'%3E");
document.write(decodeURIComponent(str.join('')));
document.write(unescape("%3Cmeta class='deferred-css' data-href='https://fonts.sony.net/shf/v31/latinextended/extra.css'%3E"));

var gwtheader;
var gwtfooter;
var responsive = true;

var respheader = "";
var nonrespheader = "";
var respfooter = "";
var nonrespfooter = "";

respheader = `${domain}/app/shared/header?includeFontType=true&includeCss=true&includeJs=true&type=responsive&locale=${locale}&account_session_link=${domain}/mysony/vn/displayname&account_signin_url=${window.theme.signInUrl}&account_signout_url=${window.theme.logOutUrl}&appId=SEA_SSO&includeReturnUri=false&syncLocalStorageAcrossDomains=true`;

respfooter = domain + '/app/shared/footer?includeFontType=true&includeCss=true&includeJs=true&type=responsive&locale=' + locale;
 
jQuery(document).ready(function () {
    $("tbody").attr("style", "overflow-x: hidden");
    $("form").attr("style", "margin-bottom: 0");

    // GWT SHF
    jQuery('meta').each(function () {
        if (jQuery(this).attr('name') == 'viewport') {
            responsive = true;
        }
    });
    if (responsive == true) {
        gwtheader = respheader;
        gwtfooter = respfooter;
    } else {
        gwtheader = nonrespheader;
        gwtfooter = nonrespfooter;
    }

    jQuery('.HeaderFullBleed').load(gwtheader, function () {
      setTimeout(function () {
        handleContinueShoppingCTA();
        handleWishlist();
        checkUserLogin();
      }, 1500);

        jQuery('.FooterFullBleed').load(gwtfooter, function () {
            setTimeout(function () {
                $('.HeaderFullBleed').removeClass('hide');
                $('.FooterFullBleed').removeClass('hide');
                $('#page-main-content').removeClass('hide');
                $('#custom_contactUsContent').removeClass('hide');
                $('.container-fluid').removeClass('hide');
            }, 250);
        });
    });
});

function handleContinueShoppingCTA() {
  const continueShoppingButtonElm = $('.button--continue-shoping');

  if (continueShoppingButtonElm.length) {
    continueShoppingButtonElm.on('click', function(evt) {
      evt.preventDefault();
      const url = document.referrer || '/';
      window.location.href = url;
    });
  }
}

function handleWishlist() {
  let gwxUtilityInterval = 0;
  
  gwxUtilityInterval = setInterval(() => {
    if (window.globalThis?.gwxUtilities?.favourites) {
      clearInterval(gwxUtilityInterval);
      getWishlist();
      addWishlist();
      removeWishlist();
    }
  }, 200);
}

async function handleTrackingFavoriteEvent($this, type) {
  const productSku = $this.attr('variant-sku');
  let dataGWTProduct = null;

  try {
    const getGWTResponse = await getGWTdataProductDetail(`${productSku}`);
    dataGWTProduct = getGWTResponse?.data;
  } catch (error) {
    dataGWTProduct = null;
  } finally {
    const sellingPrice = Number($this.attr('selling-price'))?.toFixed(2)?.toString();
    const dataDetail = {
      type,
      sku: productSku,
      model: $this.attr('cart-model'),
      superModel: $this.attr('cart-super-model'),
      category: $this.attr('cart-sixcode'),
      gwCategory1: dataGWTProduct?.mainCategory?.[0] || '',
      gwCategory2: dataGWTProduct?.mainCategory?.[1] || '',
      gwCategory3: dataGWTProduct?.mainCategory?.[2] || '',
      gwSku: dataGWTProduct?.sku || '',
      gwModel: dataGWTProduct?.modelName || '',
      gwSupermodel: dataGWTProduct?.superModelName || '',
      selling_price: sellingPrice,
      price: $this.attr('compare-at-price') ? Number($this.attr('compare-at-price'))?.toFixed(2)?.toString() : sellingPrice,
      loyaltypoints: String((Number($this.attr('selling-price')) / 1000) * 1)
    };
    var event = new CustomEvent('cartEvent', {
      detail: dataDetail
    });

    document.dispatchEvent(event);
  }
}

function addWishlist() {
  $(document).on('click', '.wishlist_collections:not(.btn-active)', function (e) {
    e.preventDefault();
    const $this = $(this);

    $this.prop('disabled', true);

    const variantId = $this.attr('variantid');
    const productId = $this.attr('data-id');

      callAPIWithGWXToken('favorite/add', 'POST', [{
        "d2c_parent_id": productId,
        "d2c_id": variantId
      }]).then(() => {
        window.globalThis?.gwxUtilities?.favourites?.addToFavourites(variantId)
          .then(async (isSuccess) => {

            /** INFO: handle tracking cartEvent - AA tracking */
            await handleTrackingFavoriteEvent($this, "favoriteAdd");
          })
          .catch(err => {
            console.log("add", variantId, 'to gwx favorite error', err);
          })

        $this.addClass("btn-active");
        $this.find(".tooltip").text(window.languages.added);
        $this.prop('disabled', false);
      }).catch(err => {
        console.log("err when call addWishlist API with GWX token", err);

        if (err.statusCode === 401 || err.statusCode === 403) {
          window.globalThis?.gwxUtilities?.favourites?.addToFavourites(variantId)
            .then(async (isSuccess) => {
              $this.addClass("btn-active");
              $this.find(".tooltip").text(window.languages.added);
              $this.prop('disabled', false);
    
              /** INFO: handle tracking cartEvent - AA tracking */
              await handleTrackingFavoriteEvent($this, "favoriteAdd")
            })
            .catch(err => {
              console.log("add", variantId, 'to gwx favorite error', err);
            })
        }
      });
  });

  $(".wishlist_collections").mouseover(function () {
    if ($(this).hasClass("btn-active")) {
      $(this).find(".tooltip").text(window.languages.removeWishlistText);
    } else {
      $(this).find(".tooltip").text(window.languages.addWishlistText);
    }
  });
}

function removeWishlist() {
  $(document).on('click', '.btn-active', function (e) {
    e.preventDefault();
    const $this = $(this);
    $this.prop('disabled', true);

    const variantId = $this.attr('variantid');
    const productId = $this.attr('data-id');

      callAPIWithGWXToken('favorite/remove', 'DELETE', [{
        "d2c_parent_id": productId,
        "d2c_id": variantId
      }]).then(() => {
        window.globalThis?.gwxUtilities?.favourites?.removeFromFavourites(variantId)
          .then(async (isSuccess) => {
            /** INFO: handle tracking cartEvent - AA tracking */
            await handleTrackingFavoriteEvent($this, "favoriteRemove");
          })
          .catch(err => {
            console.log("remove", variantId, 'from gwx favorite err', err)
          });

        $this.removeClass("btn-active");
        $this.find(".tooltip").text(window.languages.removed);
        $this.prop('disabled', false);
      }).catch(err => {
        console.log("err when call removeWishlist API with GWX token", err);

        if (err.statusCode === 401 || err.statusCode === 403) {
          window.globalThis?.gwxUtilities?.favourites?.removeFromFavourites(variantId)
            .then(async (isSuccess) => {
              $this.removeClass("btn-active");
              $this.find(".tooltip").text(window.languages.removed);
              $this.prop('disabled', false);
    
              /** INFO: handle tracking cartEvent - AA tracking */
              await handleTrackingFavoriteEvent($this, "favoriteRemove");
            })
            .catch(err => {
              console.log("remove", variantId, 'from gwx favorite err', err)
            });
        }
      });
  });

  $(document).on('click', '.wishlist-content .grid__cell .btn-active', function (e) {
    $(this).parents(".grid__cell").remove();
  });
}

function checkWishlistStatus(data) {
  $(".wishlist_collections").each(function () {
    var $this = $(this);
    var variantId = $this.attr("variantid");

    if (data.some(item => item.d2c_id === variantId)) {
      $this.addClass("btn-active");
      $this.find(".tooltip").text(window.languages.removeWishlistText);
    }
  });
}

async function getWishlist() {
  window.globalThis?.gwxUtilities?.favourites?.hasFavouritedProducts()
    .then(hasProduct => {
      console.log("Has wishlist products", hasProduct);
      if (hasProduct) {
        const wishlistElms = $(".wishlist_collections").get();

        const promises = wishlistElms.map(async (element) => {
          var $element = $(element)
          const variantId = $element.attr('variantid');
          const isFavourited = await window.globalThis?.gwxUtilities?.favourites?.isProductFavourited(variantId);

          if (isFavourited) {
            $element.addClass("btn-active");
            $element.find(".tooltip").text(window.languages.removeWishlistText);
          }
        });
      
        Promise.all(promises).then();
      }
    })
    .catch(err => {
      console.log("Check has wishlist products err", err)
    })
}

function checkUserLogin() {
  const body = jQuery('body');

  if (body.hasClass('template-customers-account') || body.hasClass('template-customers-addresses')) {
    const pathName = window.location.pathname;
    const search = window.location.search;

    callAPIWithGWXToken(`vn/displayname?_=${new Date().getTime()}`, 'GET', null, {}, window.theme.gwx_open_my_sony_url)
      .then(data => {
        if (!data.displayName) {
          // Redirect to login
          window.location.href = `${window.theme.signInUrl}${pathName}${search}`;
        }
        else {
          body.show();
        }
      })
      .catch((err) => {
        console.log("fetch gwx display name error", err);
        window.location.href = `${window.theme.signInUrl}${pathName}${search}`;
      });
  }
}
